export { default } from "./WithVisxTooltip";
